export default __webpack_public_path__ + "static/media/logo_text.6362c456.svg";